import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24dd12de"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["button xid_button", { 'disabled-color': !_ctx.enabled }]),
    disabled: !_ctx.enabled,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.enabled ? _ctx.$emit('onClick') : ''))
  }, [
    (_ctx.enabled)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "icon",
          src: _ctx.xIDIcon
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          class: "icon",
          src: _ctx.xIDIconGrey
        }, null, 8, _hoisted_3)),
    _createTextVNode(" " + _toDisplayString(_ctx.text), 1)
  ], 10, _hoisted_1))
}